const getCSSVarValue = key => getComputedStyle(document.documentElement).getPropertyValue(key).replace(/ +/g, '');

export default getCSSVarValue;
